/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * Term Form Messages
 *
 * This contains all the text for the InviteAccept component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  termPolicyText1: {
    id: 'termsForm.termPolicyText1',
    defaultMessage: 'I acknowledge artifacts kept in Active Storage are subject to {i} and may result in {b}  in a calendar month.',
    i: 'Fair Use Active Data Storage limits',
    b: 'Active Storage Usage Overage cost per GB'
  },
  termPolicyText2: {
    id: 'termsForm.termPolicyText2',
    defaultMessage: 'I acknowledge artifacts kept in Archive Storage are billed at an {b} in a calendar month.',
    b: 'Archive Storage Usage cost per GB'
  },
  termPolicyText3: {
    id: 'termsForm.termPolicyText3',
    defaultMessage: 'I acknowledge artifacts kept in Archive Storage are not accessible on the platform and may take up to 12-hours to retrieve from long- term storage to active storage. I understand there is a {b} in a calendar month.',
    b: 'Archive Storage Retrieval cost per GB'
  },
  termPolicyText4: {
    id: 'termsForm.termPolicyText4',
    defaultMessage: 'I acknowledge {b}.',
    b: 'deleted artifacts cannot be retrieved'
  },
  endPolicy: {
    id: 'termsForm.endPolicy',
    defaultMessage: 'Click Submit to enable this policy.',
  },
  termDisablePolicy1: {
    id: 'termsForm.termDisablePolicy1',
    defaultMessage: 'I acknowledge artifacts in Active Storage prior to disabling this policy and all new artifacts after the policy is disabled will remain in Active Storage indefinitely.'
  },
  termDisablePolicy2: {
    id: 'termsForm.termDisablePolicy2',
    defaultMessage: 'I acknowledge artifacts kept in Active Storage are subject to {i} limit and may result in {b} in calendar month',
    i: 'Fair Use Active Data Storage',
    b: 'Active Storage Usage Overage cost per GB'
  },
  termDisbalePolicy3: {
    id: 'termsForm.termDisbalePolicy3',
    defaultMessage: 'I acknowledge archived artifacts prior to disabling this policy will remain in Archive Storage indefinitely and are billed at an {b} in calendar month.',
    b: 'Archive Storage Usage cost per GB'
  },
  termDisablePolicy4: {
    id: 'termsForm.termDisablePolicy4',
    defaultMessage: 'I acknowledge artifact kept in Archive Storage are not accessible on the platform and may take up to 12- hours to retrieve from long-term storage to active storage. I understand there is {b} in a calendar month.',
    b: 'Archive Storage Retrieval cost per GB'
  },
  endDisablePolicyText: {
    id: 'termsForm.endDisablePolicyText',
    defaultMessage: 'Click Submit to disable this policy.'
  },
  endChangeVersionPolicy: {
    id: 'termsForm.endChangeVersionPolicy',
    defaultMessage: 'Click Submit to enable this policy.'
  }
})